import React, { useCallback, useState, useEffect, useMemo } from "react";

import {
  StripePaymentButton,
  LOCAL,
  Local_en_Messsage,
  Local_zh_Messsage,
  PaymentRequestInfo,
  PaymentType,
  PromiseResult,
  StripPaymentIntentResult,
} from "@fantuaneats/chowbus-web-stripe-payment";
import "@fantuaneats/chowbus-web-stripe-payment/dist/index.css";
import { IntlProvider } from "react-intl";
import { StripeError } from "@stripe/stripe-js";
import { LabelType } from "screens/register/page-header";
import { POS_API_URL, useHttp } from "utils/http";
import { getConstVal, TipContent, GiftContent } from "./contant";
import { useAuth } from "context/auth-context";
import { GuestInfo } from "./draw-gift";
import { getHeaders, POS_HEADERS } from "utils/request";
import { message } from "antd";
import "./customize.css";
import { StripeInitStatus } from "@fantuaneats/chowbus-web-stripe-payment/dist/model";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import { ONLINE_PAYMENT_CHANNEL } from "types/loyalty";
import {
  AdyenPaymentButton,
  PaymentIntent
} from "@chowbus/adyen-web-pay-lib";
import {
  buildDefaultPaymentCardInfo, DisplayFormatEnum, numberFormat
} from "screens/AdyenPayments/common";
import '@adyen/adyen-web/styles/adyen.css';
import { PaybuttonV2 } from "screens/AdyenPayments/AdyenPaymentButton";
import { SyntheticEvent } from 'react';

const DESCRIPTION_MAX = 22;
export const PayButton = ({
  checkStatusMsg,
  refreshPay,
  getHeight,
  ...props
}: {
  lang: LabelType;
  orderId: string;
  orderAmount: number;
  paymentId: string;
  guestInfo: GuestInfo;
  orderNumber: string;
  setPayStatus: (val: string) => void;
  closeDraw: () => void;
  checkStatusMsg: () => boolean;
  refreshPay: () => void;
  getHeight: () => void;
}) => {
  const client = useHttp();
  const { restaurant: restaurantData } = useAuth();
  const trackCommonData = useTrackCommonData();
  const [walletPayType, setWalletType] = useState("UN" as PaymentType);

  const { countryCode, currency } = useMemo(() => {
    const countryCode = restaurantData?.data?.attributes?.country || 'US';
    let currency = 'usd';
    if (restaurantData?.configCenterPreference) {
      currency = restaurantData?.configCenterPreference[countryCode].locale?.currency || currency;
    }

    return {
      countryCode,
      currency
    }
  }, [restaurantData]);

  const { setPayStatus, closeDraw } = props;

  // const [showAdyenPaymentIndicator, setShowAdyenPaymentIndicator] = useState(false);
  const [pubKeyStatus, setPubKeyStatus] = useState(0); // 0初始化、1获取成功、-1获取失败
  const [publicKeyData, setPublicKeyData] = useState<{ publicKey: string } | null>(null); // 0初始化、1获取成功、-1获取失败
  const [stripeStatus, setStripeStatus] = useState(
    "waiting" as StripeInitStatus
  );
  const [enableApplePayFlag, setEnableApplePayFlag] = useState(false); // 是否允许发起apple支付，在Adyen环境下

  const [reqInfo, setReqInfo] = useState({
    guestId: "",
    restaurantId: restaurantData.data.id,
    restaurantName: restaurantData.data.attributes.name,
    orderId: "",
    country: countryCode,
    currency: currency,
    payAmount: 0,
    billTotalDisplayItem: {
      label: `Total `,
      amount: 0,
    },
    billDetailDisplayItems: [
      {
        label: "Total ",
        amount: 0,
      },
    ],
    wallet: {
      requestPayerName: true,
      requestPayerPhone: true,
      requestPayerEmail: true,
    },
    metaData: {
      name: "",
    },
  } as PaymentRequestInfo);

  useEffect(() => {
    if (!props.orderAmount) {
      return;
    }
    setReqInfo((val) =>
      Object.assign({}, val, {
        country: countryCode,
        currency: currency,
        guestId: props.guestInfo.id,
        orderId: props.orderId,
        payAmount: props.orderAmount,
        billTotalDisplayItem: {
          label: `Total `,
          amount: props.orderAmount,
        },
        billDetailDisplayItems: [
          {
            label: "Total ",
            amount: props.orderAmount,
          },
        ],
      })
    );
  }, [props.guestInfo.id, countryCode, currency, props.orderId, props.orderAmount]);

  //获取动态的public Key
  let fetchStripePubKey = useCallback(async () => {
    try {
      //online payment channel
      //::ADYEN::
      const payment_channel_code = restaurantData.payment_channel_code;
      const restaurantId = restaurantData.data.id;
      const data = await client(`${POS_API_URL}/api/v1/payment/public_key`, {
        method: "get",
        headers: getHeaders(POS_HEADERS),
        data: {
          channel_code: payment_channel_code || ONLINE_PAYMENT_CHANNEL.Stripe,
          restaurant_id: restaurantId,
        },
      });

      //获取appley flipper 开关
      try {
        let applePayFlipperResult = await client(
          `${POS_API_URL}/api/v1/flipper/adyen_apple_pay_for_client`,
          {
            method: "get",
            headers: getHeaders(POS_HEADERS),
            data: {
              restaurant_id: restaurantId
            },
          }
        );
        setEnableApplePayFlag(applePayFlipperResult?.switch || false);
      } catch (e) {
        setEnableApplePayFlag(false);
      }



      if (data?.public_key) {
        setPubKeyStatus(1);
        setPublicKeyData({ publicKey: data.public_key });
        //::ADYEN:: Or ::Stripe:: 
        return { publicKey: data.public_key };
      } else {
        setPubKeyStatus(-1);
        setPublicKeyData(null);
        return { publicKey: "" };
      }
    } catch (error) {
      setPubKeyStatus(-1);
      message.error(TipContent.pubError[props.lang]);
      setPublicKeyData(null);
      return { publicKey: "" };
    }
  }, [client, props.lang, restaurantData]);

  // 设置语言
  const handleMessages = (lang: string) => {
    let res = null;
    switch (lang) {
      case LOCAL.ZH:
        res = Local_zh_Messsage;
        break;
      case LOCAL.EN:
        res = Local_en_Messsage;
        break;
      default:
        res = Local_en_Messsage;
    }
    return res;
  };

  //支付成功后的回调
  let onPaymentResult = useCallback(
    (
      error: "PamentStatusCheckTimeout" | StripeError | null,
      paymentInfo: {
        paymentType: PaymentType;
        paymentId: string;
        orderId: string;
      },
      payerInfo?: {
        payerName?: string;
        payerEmail?: string;
        payerPhone?: string;
      }
    ) => {
      if (error) {
        setPayStatus("error");
        refreshPay();
        trackMixPanel(
          MIX_PANEL_EVENT.PREPAY_CLICK_PAY_FAILED,
          Object.assign({}, trackCommonData, { payType: walletPayType })
        );
        return;
      }

      // 支付成功，关闭弹框，并且
      closeDraw();
      setPayStatus("success");
      trackMixPanel(
        MIX_PANEL_EVENT.PREPAY_CLICK_PAY_SUCCESS,
        Object.assign({}, trackCommonData, { payType: walletPayType })
      );
    },
    [setPayStatus, closeDraw, refreshPay, trackCommonData, walletPayType]
  );

  //向服务端保存当前支付相关信息，后台服务会使用这些信息来执行webHook
  //来确认支付支付成功与否，需要保存额内容和backend确认
  const registerPaymentRequest = useCallback(
    async (
      paymentId: string,
      paymentIntentId: string,
      createdAt: number, //时间戳,
      payAmount: Number,
      // cardPaymentMethodInfo: CardPaymentMethodInfo,
      cardPaymentMethodInfo: any,
      paymentPlatform?: string,
      delayCaptureSeconds?: number,
    ) => {
      //
      try {
        const result = await client(
          `${POS_API_URL}/api/v1/order/${props.orderId}/payments`,
          {
            method: "post",
            headers: getHeaders(POS_HEADERS),
            data: [
              {
                id: paymentId,
                amount: payAmount, // 和下面total的关系
                authorization_code: "", // 无参数
                brand: cardPaymentMethodInfo.card.brand,
                cardholder_name: "", // 无参数
                charge_id: "", // charge_id是啥
                country: cardPaymentMethodInfo.card.country,
                currency: currency || "usd", // 是否固定
                exp_month: cardPaymentMethodInfo.card.exp_month,
                exp_year: cardPaymentMethodInfo.card.exp_year,
                funding: cardPaymentMethodInfo.card.funding,
                is_separate: false,
                guest: null, // 是啥？？？
                tips: 0,
                last4: cardPaymentMethodInfo.card.last4,
                payment_intent: paymentIntentId,
                payment_type: "card",
                total: payAmount,
                emv_auth_data: "", // 无参数
                created_at: createdAt,
                fingerprint: cardPaymentMethodInfo.card.fingerprint || "",
                card_wallet_type: cardPaymentMethodInfo.paymentType,
                payment_platform: paymentPlatform || '',
                delay_capture_seconds: delayCaptureSeconds || 0,

              },
            ],
          }
        );
        return {
          result: true,
          message: "",
          data: result,
        };
      } catch (error) {
        refreshPay();
        return getConstVal("record") as PromiseResult;
      }
    },
    [client, currency, props.orderId, refreshPay]
  );

  //取消支付
  const cancelPayment = useCallback(
    async (paymentId: string) => {
      try {
        const result = await client(
          `${POS_API_URL}/api/v1/shopping_cart/${props.orderId}/payment/${paymentId}`,
          {
            method: "delete",
            headers: getHeaders(POS_HEADERS),
          }
        );
        return {
          result: true,
          message: "",
          data: result || "success",
        };
      } catch (error) {
        refreshPay();
        return {
          result: false,
          message: "",
          data: "error",
        };
      }
    },
    [props.orderId, client, refreshPay]
  );

  //创建paymentIntent-和stripe建立支付通道，将结果返回给stripe
  const createStripePaymentIntent = useCallback(
    async (payAmount: number) => {
      const originRestaurantName = restaurantData?.data?.attributes?.name || "";
      const statementDescriptor =
        originRestaurantName.length > DESCRIPTION_MAX
          ? originRestaurantName.substring(0, DESCRIPTION_MAX)
          : originRestaurantName;
      try {
        const result = await client(
          `${POS_API_URL}/api/v1/payment/payment_intent`,
          {
            method: "post",
            headers: getHeaders(POS_HEADERS),
            data: {
              amount: payAmount,
              currency: currency,
              description: "POS*PrepaidCard*Order",
              payment_method_types: ["card"],
              statement_descriptor: statementDescriptor,
              confirm: false,
              capture_method: "manual", // 是否固定
              // todo: payment_method传 500，接口就报错
              payment_method: "", // 哪里来
              order_source: 'loyalty',
              return_url: 'https://loyalty-web.chowbus.com',
              channel_code: restaurantData?.payment_channel_code || ONLINE_PAYMENT_CHANNEL.Stripe,
              order_number: props.orderNumber,
              payment_meta_data: {
                chowbus_product_line: "gift_card",
                order_id: props.orderId,
                payment_id: props.paymentId,
                guest: props.guestInfo,
                restaurant_id: restaurantData?.data?.id,//add restaurant_id for chowbus_product_line
              },
            },
          }
        );

        // delay_capture_seconds, payment_platform, session_data, session_id
        return {
          data: {
            paymentId: props.paymentId,
            paymentIntent: {
              id: result?.id,
              object: "payment_intent" as const,
              amount: result?.amount,
              canceled_at: result?.canceled_at,
              cancellation_reason: result?.cancellation_reason,
              capture_method: result?.capture_method,
              client_secret: result?.client_secret,
              confirmation_method: result?.confirmation_method,
              created: result?.created,
              currency: result?.currency,
              description: result?.description,
              last_payment_error: result?.last_payment_error,
              livemode: result?.livemode,
              next_action: result?.next_action,
              payment_method: result?.payment_method,
              payment_method_types: result?.payment_method_types,
              receipt_email: result?.receipt_email,
              setup_future_usage: result?.setup_future_usage,
              shipping: result?.shipping,
              status: result?.status,
            },
          },
        };
      } catch (error) {
        refreshPay();
        return getConstVal("intent") as StripPaymentIntentResult;
      }
    },
    [
      client,
      currency,
      props.orderId,
      props.guestInfo,
      props.paymentId,
      props.orderNumber,
      refreshPay,
      restaurantData?.data?.attributes?.name,
      restaurantData?.data?.id,
      restaurantData?.payment_channel_code,
    ]
  );

  const createStripePaymentIntentForAdyen = useCallback(
    async (payAmount: number) => {
      const originRestaurantName = restaurantData?.data?.attributes?.name || "";
      const statementDescriptor =
        originRestaurantName.length > DESCRIPTION_MAX
          ? originRestaurantName.substring(0, DESCRIPTION_MAX)
          : originRestaurantName;
      try {
        const result = await client(
          `${POS_API_URL}/api/v1/payment/payment_intent`,
          {
            method: "post",
            headers: getHeaders(POS_HEADERS),
            data: {
              amount: payAmount,
              currency: currency || "usd",
              description: "POS*PrepaidCard*Order",
              payment_method_types: ["card"],
              statement_descriptor: statementDescriptor,
              confirm: false,
              capture_method: "manual", // 是否固定
              // todo: payment_method传 500，接口就报错
              payment_method: "", // 哪里来
              order_source: 'loyalty',
              return_url: 'https://loyalty-web.chowbus.com',
              channel_code: restaurantData?.payment_channel_code || ONLINE_PAYMENT_CHANNEL.Stripe,
              order_number: props.orderNumber,//adyen required
              payment_meta_data: {
                chowbus_product_line: "gift_card",
                order_id: props.orderId,
                payment_id: props.paymentId,
                guest: props.guestInfo,
                restaurant_id: restaurantData?.data?.id,//add restaurant_id for chowbus_product_line
              },
            },
          }
        );

        // delay_capture_seconds, payment_platform, session_data, session_id
        return {
          data: {
            paymentId: props.paymentId,
            paymentIntent: {
              id: result?.id,
              object: "payment_intent" as const,
              amount: result?.amount,
              canceled_at: result?.canceled_at,
              cancellation_reason: result?.cancellation_reason,
              capture_method: result?.capture_method,
              client_secret: result?.client_secret,
              confirmation_method: result?.confirmation_method,
              created: result?.created,
              currency: result?.currency,
              description: result?.description,
              last_payment_error: result?.last_payment_error,
              livemode: result?.livemode,
              next_action: result?.next_action,
              payment_method: result?.payment_method,
              payment_method_types: result?.payment_method_types,
              receipt_email: result?.receipt_email,
              setup_future_usage: result?.setup_future_usage,
              shipping: result?.shipping,
              status: result?.status,

              paymentPlatform: result.payment_platform,
              delayCapture_seconds: result.delay_capture_seconds,
              sessionData: result.session_data,
              sessionId: result.session_id,
            },
          },
        };
      } catch (error) {
        refreshPay();
        return getConstVal("intent") as StripPaymentIntentResult;
      }
    },
    [
      currency,
      client,
      props.orderId,
      props.guestInfo,
      props.paymentId,
      props.orderNumber,
      refreshPay,
      restaurantData?.data?.attributes?.name,
      restaurantData?.data?.id,
      restaurantData?.payment_channel_code,

    ]
  );


  //client端支付提交后，用户检查支付知否最终被stripe确认
  const checkPaymentPayStatus = useCallback(
    (paymentId: string, orderId: string) => {
      return new Promise<boolean>((resolve) => {
        resolve(true);
      });
    },
    []
  );

  //当前支付选择的支付方式的回调
  const onPaymentTypeActived = useCallback((paymentType: PaymentType) => {
    setWalletType(paymentType);
  }, []);

  const doPaymentBizEnable = useCallback(async () => {
    const flag = checkStatusMsg();
    if (flag) {
      trackMixPanel(
        MIX_PANEL_EVENT.PREPAY_CLICK_START_PAY,
        Object.assign({}, trackCommonData, { payType: walletPayType })
      );
    }
    return flag;
  }, [checkStatusMsg, trackCommonData, walletPayType]);

  const onStripeInitializing = useCallback(
    (result: StripeInitStatus) => {
      if (result === "success" && stripeStatus !== "success") {
        getHeight();
      }

      setStripeStatus(result);
    },
    [getHeight, stripeStatus]
  );

  useEffect(() => {
    (async function () {
      if (restaurantData && restaurantData.payment_channel_code === ONLINE_PAYMENT_CHANNEL.Adyen) {
        let publicKeyData = await fetchStripePubKey();
        setPublicKeyData(publicKeyData);
      }
    }());

  }, [restaurantData, fetchStripePubKey]);

  console.log("restaurantData on pay button", restaurantData);
  return (
    // @ts-ignore
    <>
      {pubKeyStatus !== -1 && (
        <div className="payBox">
          <IntlProvider
            locale={props.lang}
            messages={handleMessages(props.lang)}
          >
            {
              restaurantData.payment_channel_code === ONLINE_PAYMENT_CHANNEL.Stripe && <StripePaymentButton
                fetchStripePubKey={fetchStripePubKey}
                local={LOCAL.EN}
                paymentRequestInfo={reqInfo}
                onPaymentResult={onPaymentResult}
                registerPaymentRequest={registerPaymentRequest}
                cancelPayment={cancelPayment}
                createStripePaymentIntent={createStripePaymentIntent}
                checkPaymentPayStatus={checkPaymentPayStatus}
                onPaymentTypeActived={onPaymentTypeActived}
                doPaymentBizEnable={doPaymentBizEnable}
                onStripeInitializing={onStripeInitializing}
                assets={{
                  entryCardNumberLabelClass: "entryCardNumberManuallyLabel",
                }}
              >
                {/**为不支持Apple pay场景下，为输入卡号支付提供入口 自定义*/}
                {/*
              // @ts-ignore */}
                {(onClick: () => void) => {
                  // @ts-ignore
                  return (
                    <React.Fragment>
                      <div
                        className={
                          !!props.orderAmount
                            ? "paymentButton hasAmount"
                            : "paymentButton"
                        }
                        onClick={onClick}
                      >
                        <span>
                          {GiftContent.savePay[props.lang]}
                          {props.orderAmount / 100}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                }}
              </StripePaymentButton>
            }
            {
              restaurantData.payment_channel_code === ONLINE_PAYMENT_CHANNEL.Adyen && pubKeyStatus === -1 && <React.Fragment>
                AdyenPament init Error
              </React.Fragment>
            }
            {
              restaurantData.payment_channel_code === ONLINE_PAYMENT_CHANNEL.Adyen && pubKeyStatus === 1 && <React.Fragment>
                <AdyenPaymentButton config={{
                  publicKey: publicKeyData?.publicKey || '',
                  orderId: props.orderId,
                  orderNumber: '',
                  payAmount: props.orderAmount || 0,
                  locale: props.lang === 'en' ? 'en-US' : 'zh-CN',
                  enviroment: (`${process.env.REACT_APP_ADYEN_ENV}` || 'test') as 'live-us',
                  paymentServiceUrl: process.env.REACT_APP_CHOWBUS_ADYEN_PAYMENT_DOMAIN || 'https://pos-pay-staging-01.chowbus.com',
                  // paymentServiceUrl: 'https://qr-adyen.ngrok.io',
                  // iframeContainerClassName: '',
                  debug: process.env.REACT_APP_ADYEN_ENV === 'test' ? true : false,
                  merchantName: (props.lang === 'en' ? restaurantData.data.attributes.name : restaurantData.data.attributes.foreign_name) || restaurantData.data.attributes.name || 'chowbus',
                  checkoutPageFullScreenOnMobile: false,
                  enableApplyPayIfCan: enableApplePayFlag,
                }}
                  getPaymentIntent={async (resolveCallback: (paymentIntent: PaymentIntent) => void, rejectCallback: () => void) => {
                    let stripPaymentIntentResult: StripPaymentIntentResult = await createStripePaymentIntentForAdyen(props.orderAmount || 0);
                    if (!stripPaymentIntentResult.data.paymentId) {
                      rejectCallback();
                    } else {
                      let paymentIntent = stripPaymentIntentResult.data.paymentIntent as any;
                      resolveCallback({
                        publicKey: publicKeyData?.publicKey || '',
                        paymentId: stripPaymentIntentResult.data.paymentId,
                        amount: props.orderAmount || 0,
                        paymentPlatform: paymentIntent.paymentPlatform,
                        sessionId: paymentIntent.sessionId,
                        sessionData: paymentIntent.sessionData,
                        delayCaptureSeconds: paymentIntent.delayCapture_seconds,
                        interactId: paymentIntent.interactId || '',
                        clientSecret: paymentIntent.client_secret || '',
                      });
                    }
                  }}
                  onBeforeSubmit={async (para: {
                    paymentIntent: PaymentIntent;
                    resolve: (paymentIntent: PaymentIntent) => void;
                    reject: () => void;
                  }) => {
                    let { paymentIntent, resolve: resolveCallback, reject: rejectCallback } = para;
                    let { sessionId,
                      paymentPlatform,
                      delayCaptureSeconds,
                      paymentId
                    } = paymentIntent;

                    const cardPaymentMethodInfo = {
                      paymentMethodId: '',
                      cardInfo: buildDefaultPaymentCardInfo(),
                      // cardLast4: '',
                      customer: null,
                      paymentType: 'card',
                      metadata: {},
                    };

                    try {
                      await registerPaymentRequest(
                        paymentId,
                        sessionId,
                        new Date().getTime(), //时间戳,
                        props.orderAmount || 0,
                        cardPaymentMethodInfo,
                        paymentPlatform,
                        delayCaptureSeconds || 0,
                      );

                      resolveCallback(paymentIntent);
                    } catch (e) {
                      rejectCallback();
                    } finally {

                    }

                  }}

                  onPaymentComplete={(parameter: { resultCode: string, }) => {
                    onPaymentResult(null, {
                      paymentType: PaymentType.BankCard_CreditCard,
                      paymentId: '',
                      orderId: '',
                    });
                    // setShowAdyenPaymentIndicator(false);
                  }}

                  onPaymentFailed={() => {
                    onPaymentResult('PamentStatusCheckTimeout', {
                      paymentType: PaymentType.BankCard_CreditCard,
                      paymentId: '',
                      orderId: '',
                    });
                    // setShowAdyenPaymentIndicator(false);
                  }}

                  onError={(errobj: { errorCode: string, errorMessage: string }) => {
                    // onPaymentResult('PamentStatusCheckTimeout', {
                    //   paymentType: PaymentType.BankCard_CreditCard,
                    //   paymentId: '',
                    //   orderId: '',
                    // });
                    // setShowAdyenPaymentIndicator(false);
                  }}

                  afterConfirmPayment={async (parameter: { paymentIntent: PaymentIntent, resolve: () => void, reject: () => void }) => {
                    let { paymentIntent, resolve, } = parameter;
                    await checkPaymentPayStatus(paymentIntent.paymentId, '');
                    resolve();
                  }}
                  onCancelPaymentCheckoutPage={(parameter: { resolve: () => void, reject: () => void }) => {
                    let { resolve } = parameter;
                    resolve();
                  }}
                  onPaymentCancelled={() => {
                    // setShowAdyenPaymentIndicator(false);
                  }}
                >
                  <PaybuttonV2 localization={
                    {
                      en: {
                        'cancel_button': 'Cancel',
                        'payment_title': 'Pay',
                        'credite_card_pay_button': `Confirm and pay · $${numberFormat((props.orderAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}`,
                      },
                      zh: {
                        'cancel_button': '取消',
                        'payment_title': '支付',
                        'credite_card_pay_button': `确认并支付 · $${numberFormat((props.orderAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}`,
                      }
                    }}
                    currentLanguage={props.lang as LOCAL}
                    paymentAmount={props.orderAmount || 0}
                    onClick={(event: SyntheticEvent) => {
                      const flag = checkStatusMsg();
                      if (!flag) {
                        event.stopPropagation();
                      }
                    }}
                  />

                </AdyenPaymentButton>
              </React.Fragment>
            }

          </IntlProvider>
        </div>
      )}
    </>
  );
};
